<template>
    <app-layout>
        <template #page-content>
            <div id="sl-topo__thanks" class="px-2 py-4">
                <div class="success-box">
                    <div class="success-box__contents">
                        <h2>
                            {{ $t('thank_you.heading') }}
                        </h2>

                        <p>
                            {{ $t('thank_you.paragraph_1') }}
                        </p>

                        <p v-if="requestType === 'ORDER'">
                            {{ $t('thank_you.paragraph_2.order') }}
                        </p>

                        <p v-else>
                            {{ $t('thank_you.paragraph_2.inquiry') }}
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/layouts/AppLayout.vue';

export default
{
    name: 'FilesSent',

    components:
    {
        AppLayout,
    },

    computed:
    {
        requestType()
        {
            return this.$route.params.requestType.toUpperCase();
        },
    },
};
</script>

<style lang="css">
@reference "@/assets/styles/main.css";

.success-box
{
    @apply flex justify-center;

    & > .success-box__contents
    {
        @apply rounded-lg shadow-md px-12 py-8
            bg-green-200/30 text-green-800
            backdrop-blur-xs transition-all
            hover:shadow-lg hover:backdrop-blur-sm;

        & h2
        {
            @apply text-green-900;
        }
    }

    &::selection
    {
        @apply bg-green-600;
    }
}
</style>
